const Register = () => (
  <div className="container">
    <h1 className='scroll-m-20 text-center text-4xl font-extrabold tracking-tight text-balance'>Register page</h1>
  </div>
);

export default Register;
